// @flow
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Profile from '../components/Profile';
import {actions as AuthAction} from '../../auth/duck';
import {actions as OrderAction} from '../../order/duck';
import {actions as ProfileAction} from '../../profile/account/duck';
import {actions as CheckoutAction} from '../../checkout/duck';

import type {RootState} from '../../index';
import type {Dispatch} from 'redux';

export default connect(
  (state: RootState) => ({
    user: state.auth.user,
    store: state.store.store,
    subscription: state.tiersList.currentSubscription,
  }),
  (dispatch: Dispatch<any>) =>
    bindActionCreators(
      {
        ...ProfileAction,
        ...OrderAction,
        ...AuthAction,
        ...CheckoutAction,
      },
      dispatch
    )
)(Profile);
